module.exports = __webpack_public_path__ + "img/img-28b736.png";